import { get, getFromCache } from "../../../shared/data";

export const flattenOptions = (opts) => {
    if (opts && opts.length < 0) {
        return [];
    }

    return opts.reduce((arr, opt) => {
        arr.push(opt);

        if (opt.sub) {
            opt.sub.forEach((subOpt) => {
                arr.push({ ...subOpt, displayText: `${opt.text}: ${subOpt.text}` });
            });
        }

        return arr;
    }, []);
};

export const getProvider = (url) => {
    return getFromCache(url);
};

export const getProviderByTerm = (term, path, tags) => {
    const tagsParam = tags && tags.length > 0 ? `&tags=${tags.join(",")}` : "";
    const url = `${path}?contains=${term}${tagsParam}`;

    return get(url);
};
